import uniq from 'lodash.uniq';

import { ProjectPropertyType } from 'src/constants/project';
import { ProjectModelProperty } from 'src/store/state/projects';
import { XSD_IRI } from 'src/templates/queries/iris';
import { ModelPropertyBindingResult } from 'src/templates/queries/modelProperties';

export const parseModelPropertyResults = (
  results: ModelPropertyBindingResult[]
) =>
  Object.values(
    results.reduce<
      Record<
        string,
        Omit<ProjectModelProperty, 'isDatatype'> & { isDatatype?: boolean }
      >
    >((acc, result) => {
      const iri = result.property?.value;
      if (!iri) {
        return acc;
      }

      if (!acc[iri]) {
        acc[iri] = {
          iri,
          domain: [],
          range: [],
          parents: [],
          propertyType: ProjectPropertyType.RDFS,
        };
      }

      const isDatatype = result.isDatatype?.value;
      if (isDatatype === 'true') {
        acc[iri].isDatatype = true;
      } else if (isDatatype === 'false') {
        acc[iri].isDatatype = false;
      }

      const domain = result.domain?.value;
      if (domain) {
        acc[iri].domain = uniq([...acc[iri].domain, domain]);
      }

      const range = result.range?.value;
      if (range) {
        acc[iri].range = uniq([...acc[iri].range, range]);
      }

      const domainIncludes = result.domainIncludes?.value;
      if (domainIncludes) {
        acc[iri].domain = uniq([...acc[iri].domain, domainIncludes]);
        acc[iri].propertyType = ProjectPropertyType.SCHEMA_ORG;
      }

      const rangeIncludes = result.rangeIncludes?.value;
      if (rangeIncludes) {
        acc[iri].range = uniq([...acc[iri].range, rangeIncludes]);
        acc[iri].propertyType = ProjectPropertyType.SCHEMA_ORG;
      }

      const parent = result.parent?.value;
      if (parent) {
        acc[iri].parents = uniq([...acc[iri].parents, parent]);
      }

      return acc;
    }, {})
  ).reduce<Record<string, ProjectModelProperty>>((acc, result) => {
    acc[result.iri] = {
      ...result,
      isDatatype:
        result.isDatatype ??
        (result.range.length
          ? result.range.every((range) => range.startsWith(XSD_IRI))
          : undefined),
    };
    return acc;
  }, {});
